var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCertificate = function SvgCertificate(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5 19h-8A1.5 1.5 0 0 1 3 17.5v-11A1.5 1.5 0 0 1 4.5 5h15A1.5 1.5 0 0 1 21 6.5v11a1.5 1.5 0 0 1-1.5 1.5h-2v1a.5.5 0 0 1-.697.46L15 19.687l-1.803.773A.5.5 0 0 1 12.5 20v-1ZM4 6.5a.5.5 0 0 1 .5-.5h15a.5.5 0 0 1 .5.5v11a.5.5 0 0 1-.5.5h-2v-2.341a3 3 0 1 0-5 0V18h-8a.5.5 0 0 1-.5-.5v-11Zm9.5 12.003v-1.904c.441.255.954.401 1.5.401s1.059-.146 1.5-.401v2.643l-1.303-.559a.5.5 0 0 0-.394 0l-1.303.559v-.74ZM15 16a1.997 1.997 0 0 0 2-2 2 2 0 1 0-2 2Z",
    fill: "currentColor"
  })));
};
export default SvgCertificate;